// The pages in this window's history, apart from the entries pushed for what
// lies over the screen (a phone's menu, phone/history.ts): such an entry has
// the same URL and is not a page.
import type { RouterHistory } from "@tanstack/react-router";

/** The mark in an overlay entry's state. */
export const OVERLAY_MARK = "trameriaOverlay";

/** Whether the current entry is the one pushed for an overlay. */
export function isOverlayEntry(history: RouterHistory): boolean {
  const state: unknown = history.location.state;
  return (
    typeof state === "object" &&
    state !== null &&
    (state as Record<string, unknown>)[OVERLAY_MARK] === true
  );
}

/** The place in history of the page shown (under an overlay's entry: the page's). */
function pageIndex(history: RouterHistory): number {
  const at = history.location.state?.__TSR_index ?? 0;
  return isOverlayEntry(history) ? at - 1 : at;
}

/** Whether this window has a page before the one shown (not counting an overlay's entry). */
export function hasPageBefore(history: RouterHistory): boolean {
  return pageIndex(history) > 0;
}
